import type { MutationHookOptions } from "@apollo/client";
import { useMutation, gql } from "@apollo/client";

import type { MigrationStatus } from "@shared/types/graphqlGenerated";

const WELLEVATE_ACCOUNT_ACTIVATION_MUTATION = gql`
  mutation WellevateAccountActivation_Shared_Mutation($input: AccountActivationInput!) {
    patient {
      wellevateAccountActivation(input: $input) {
        migrationStatus {
          status
        }
        errors {
          message
        }
      }
    }
  }
`;

interface WellevateAccountActivationData {
  patient: {
    wellevateAccountActivation: {
      migrationStatus: MigrationStatus;
      errors: {
        message: string;
      };
    };
  };
}

interface Variables {
  input: {
    token: string;
    activate: boolean;
  };
}

const useWellevateAccountActivation = (
  options?: MutationHookOptions<WellevateAccountActivationData, Variables>
) =>
  useMutation<WellevateAccountActivationData, Variables>(
    WELLEVATE_ACCOUNT_ACTIVATION_MUTATION,
    options
  );

export {
  type WellevateAccountActivationData,
  useWellevateAccountActivation,
  WELLEVATE_ACCOUNT_ACTIVATION_MUTATION,
};
